import { notification } from "antd";

import codeMessage from "./codeMessage";

const successHandler = (
  response,
  showSuccessNotification = true,
  typeNotification = {}
) => {
  if (!response?.data?.result && response?.result !== null) {
    response = {
      ...response,
      status: 404,
      url: null,
      data: {
        success: false,
        result: null,
      },
    };
  }
  const { data } = response;
  if (data.success === false) {
    const message = data && data.message;
    const errorText = message || codeMessage[response.status];
    const { status } = response;
    notification.config({
      duration: 3,
    });
    notification.error({
      // message: `Request error ${status}`,
      description: errorText,
      key: errorText, //used to remove deuplicate messages
    });
  } else {
    const message = data && data?.message;
    const successText = message || codeMessage[response.status];
    const { status } = response;
    if (showSuccessNotification) {
      notification.config({
        duration: 3,
      });
      notification.success({
        // message: `Request success`,
        description: successText,
      });
    }
  }

  return data;
};

export default successHandler;
